import React from 'react'

function StatsSection({ stats }) {
    return (
        <div className='mx-6 mt-10 mb-20 lg:mt-11 lg:mb-[64px] lg:mx-[125px] lg:my-[64px] grid grid-cols-2 lg:grid-cols-4 gap-4 gap-y-[70px] lg:gap-y-0 lg:gap-[70px]'>
            {stats.map((stat, index) => (
                <div key={index} className='flex lg:items-center gap-4'>
                    <img src={stat.icon} alt={stat.alt} className='h-10 w-10 lg:h-[56px] lg:w-[56px]' />
                    <div className='flex flex-col gap-2'>
                        <p className='text-[#27506E] font-semibold text-2xl leading-[26px] lg:text-[31px] lg:leading-[26px]'>{stat.value}</p>
                        <p className='text-sm leading-[20px] lg:text-base lg:leading-[26px] font-normal'>{stat.description}</p>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default StatsSection